/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class o{constructor(o,s,t){this.row=o,this.colFrom=s,this.colTo=t}}export{o as default};
